import { protectedRoute } from "@/lib/protectedRoute";
import { TemplateEdit } from "@/pages/TemplateEdit";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/template/$templateId")({
  component: TemplateEdit,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
